import { MainContentArea, ContentHeader } from "melco-ui";
import { useParams } from "react-router-dom";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { useDesignMapping } from "../../hooks/designMappings/useDesignMapping";
import { DesignMappingDetailForm } from "../../components/designMappings/DesignMappingDetailForm";
import { HeaderButtonArea } from "melco-shared-logic";
import { DesignMappingDuplicateButton } from "../../components/designMappings/DesignMappingDuplicateButton";

export const DesignMappingDetails: React.FC = () => {
  const breadcrumb = useBreadcrumb("designMappings");

  const { designMappingId } = useParams<{
    designMappingId: string;
  }>();

  const { data: designMapping } = useDesignMapping(designMappingId ?? "");

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={designMapping?.name ?? ""}
          breadcrumb={breadcrumb}
          extra={
            <>
              <DesignMappingDuplicateButton
                designMappingId={designMappingId ?? ""}
              />
              <HeaderButtonArea />
            </>
            /*
            <>
              <FontDuplicateButton fontId={fontId ?? ""} />
              <FontDownloadButton
                fontId={fontId ?? ""}
                fontFilename={font?.file_name ?? ""}
              />
              {font && (
                <FontDetailMoreActionButton
                  font={font}
                  referencesDrawer={referencesDrawer}
                />
              )}
            </>
            */
          }
        />
      }
      contentPadding
    >
      {designMapping && (
        <DesignMappingDetailForm designMapping={designMapping} />
      )}
    </MainContentArea>
  );
};
